import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createOrUpdateProductGroup() {
    yield takeEvery(actions.CREATE_OR_UPDATE_PRODUCT_GROUP_REQUESTED, function* (action) {
        try {
            const productGroup = yield call(actions.createOrUpdateProductGroup, action.payload);
            yield put({ type: actions.CREATE_OR_UPDATE_PRODUCT_GROUP_SUCCEEDED, productGroup });
        } catch (error) {
            yield put({ type: actions.CREATE_OR_UPDATE_PRODUCT_GROUP_FAILED, error: error.response.data.message });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(createOrUpdateProductGroup)
    ]);
}
